import { useGLFlags } from '@group-link-one/gl-utils';
import { UTLoading } from '@group-link-one/gl-ui/utilities';
import type { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '@/Auth';

interface VerifyAuthenticatedRouteProps {
  needAuth?: boolean;
  element: React.ReactElement;
  userHasPrivileges?: boolean;
}

export const VerifyRoute = ({
  needAuth,
  userHasPrivileges,
  element,
}: VerifyAuthenticatedRouteProps): JSX.Element => {
  const { flagsAlreadyLoaded, isOrgBlocked } = useGLFlags();
  const authenticated = isAuthenticated();

  // Show loading while flags are loading
  if (!flagsAlreadyLoaded) {
    return <UTLoading screen='as-full-screen' type='dots' />;
  }

  // For authenticated routes
  if (needAuth) {
    // Check if user is authenticated
    if (!authenticated) {
      return <Navigate to='/' replace />;
    }

    // Check if organization is blocked
    if (isOrgBlocked) {
      return <div>Organization is blocked</div>;
    }

    // Check user privileges if specified
    if (userHasPrivileges === false) {
      return <Navigate to='/' replace />;
    }
  }

  // For unauthenticated routes (like login)
  if (needAuth === false && authenticated) {
    return <Navigate to='/' replace />;
  }

  return element;
};
